import { EmptyState as ChakraEmptyState, VStack } from 'chakra-ui-next'
import * as React from 'react'
import { LuX } from 'react-icons/lu'
import { Button } from './button'

export interface ErrorStateProps extends ChakraEmptyState.RootProps {
  title?: string
  description?: string
  icon?: React.ReactNode
  onRetry?: () => void
}

export const ErrorState = React.forwardRef<HTMLDivElement, ErrorStateProps>(
  function EmptyState(props, ref) {
    const {
      title = 'Something went wrong',
      description = 'If the problem persists, please contact support',
      icon = <LuX />,
      children,
      onRetry,
      ...rest
    } = props
    return (
      <ChakraEmptyState.Root ref={ref} {...rest}>
        <ChakraEmptyState.Content gap={6}>
          {icon && (
            <ChakraEmptyState.Indicator>
              <VStack
                p={3}
                borderWidth={1}
                borderRadius="xl"
                bg="bg.error"
                borderColor="border.error/20"
                w="12"
                h="12"
                color="fg.error"
              >
                {icon}
              </VStack>
            </ChakraEmptyState.Indicator>
          )}

          {description ? (
            <VStack textAlign="center">
              <ChakraEmptyState.Title mb="1">{title}</ChakraEmptyState.Title>
              <ChakraEmptyState.Description>{description}</ChakraEmptyState.Description>
            </VStack>
          ) : (
            <ChakraEmptyState.Title>{title}</ChakraEmptyState.Title>
          )}
          {onRetry && (
            <Button variant="outline" onClick={onRetry}>
              Retry
            </Button>
          )}
        </ChakraEmptyState.Content>
      </ChakraEmptyState.Root>
    )
  },
)
